import {Form, Formik} from "formik";
import React from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import NsField from "../../components/fields/NsField";

export default function ModificaCommentoKpiView({
                                                    idKpi,
                                                    idCommento,
                                                    commento,
                                                    formikRef,
                                                    show,
                                                    setShow,
                                                    modalMsg,
                                                    signupSchema,
                                                    onSubmitForm,
                                                    bottoniSx,
                                                    bottoniDx,
                                                    initialFormValues,
                                                }) {

    return (
        <Card
            icon={'fas fa-comment'}
            title={!commento ? 'Inserisci Commento' : commento.modificabile ? 'Modifica Commento' : 'Visualizza Commento'}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            <ModalMsg
                show={show}
                handleClose={() => {
                    setShow(false);
                }}
                testo={modalMsg}/>
            <Formik
                initialValues={initialFormValues}
                innerRef={formikRef}
                validationSchema={signupSchema}
                onSubmit={onSubmitForm}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="row g-3">
                        <div className="col-md-12">
                            <NsField
                                name={"testo"}
                                label={"Testo*:"}
                                as={'textarea'}
                                isDisabled={idCommento && (!commento || !commento.modificabile)}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                            <input type="hidden" name="id_kpi" id="id_kpi" value={idKpi}/>
                        </div>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}